/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { Splide } from '@splidejs/splide';
import type { Components } from '../../../index';

export type EfbArticleSlide = Components.EfbArticleSlide;

@Component({
  tag: 'efb-article-slider',
  styleUrl: 'article-slider.scss',
  shadow: true,
})
export class EfbArticleSlider {
  private sliderElement!: HTMLElement;

  private slider: Splide;

  /**
   * Props
   */

  @Prop() data: Array<EfbArticleSlide> | string;

  @Memoize('data')
  get parsedData(): Array<EfbArticleSlide> {
    return parseIfString(this.data);
  }

  /**
   * Lifecycle Hooks
   */

  componentDidLoad() {
    this.slider = new Splide(this.sliderElement, {
      type: 'slide',
      fixedWidth: 352,
      gap: 32,
      pagination: true,
      focus: 0,
      omitEnd: true,
      breakpoints: {
        768: {
          fixedWidth: 296,
          gap: 16,
        },
      },
    }).mount();
  }

  disconnectedCallback() {
    this.slider.destroy();
  }

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <div
          class="splide"
          role="group"
          aria-label="Products slider"
          ref={(el) => {
            this.sliderElement = el as HTMLElement;
          }}
        >
          {/* Slides */}
          <div class="splide__track">
            <div class="splide__list">
              {this.parsedData.map((item) => (
                <efb-article-slide class="splide__slide" {...item}></efb-article-slide>
              ))}
            </div>
          </div>

          {/* Arrows */}
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <efb-icon name="back-arrow" />
            </button>
            <button class="splide__arrow splide__arrow--next">
              <efb-icon name="forward-arrow" />
            </button>
          </div>
        </div>
      </Host>
    );
  }
}
